let iframe = {
    resizeIframe: function (formblock, apiBaseUrl) {
        var iframe = document.getElementById(formblock);

        if (iframe) {
            window.addEventListener("message", function (e) {
                var this_frame = document.getElementById(formblock);

                if (this_frame && this_frame.contentWindow === e.source && e.data?.height) {
                    var height = e.data.height + 50;
                    var scrollUp = e.data.scrollUp;
                    var previousHeight = this_frame.height || 0;
                    this_frame.height = height;
                    this_frame.style.maxHeight = height + "px";

                    if (scrollUp) {
                        var toDialog = e.data.toDialog;
                        var top = -100;
                        if (toDialog > 0 && window.innerWidth < 600) {
                            top = height / 2 - toDialog - 100;
                        }
                        if (iframe) {
                            setTimeout(() => {
                                window.scroll({
                                    top: iframe.offsetTop + top,
                                    left: 0,
                                    behavior: 'smooth'
                                });
                            }, 100);
                        }
                    }
                }
            });

            iframe.addEventListener("load", function () {
                if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage({
                        currentUrl: window.location.href,
                        bankidApiBase: apiBaseUrl
                    }, "*");
                }
            });
        }
    }
}

export { iframe };